import { BaseComponent } from '../../base-component';
import { shouldShowBounceGate } from './activation-handler';
import { generateEventMergeId } from '../../_common/client/tracking';
import { renderBounceLayerRecommendations } from '@otto-ec/nexus-registry/reco/cinemas';
import { sheetV1 } from '@otto-ec/otto-components/sheet';

export class BounceGateComponent extends BaseComponent {
    public readonly rootSelector: string = '.js_pdp_bounce-gate';

    public async init(): Promise<void> {
        this.registerFt9BounceLayerEvent();
        if (this.getRootElement().dataset.isExternalCall === 'true') {
            document.documentElement.addEventListener('mouseleave', event => this.handleMouseLeaveEvent(event));
        }
    }

    public async onHtmlLoaded(): Promise<unknown> {
        return;
    }

    private registerFt9BounceLayerEvent() {
        o_global.eventQBus.on('ft9.bouncelayer.open', () => this.openSheet());
    }

    private async handleMouseLeaveEvent(event: MouseEvent) {
        if (await shouldShowBounceGate(event)) {
            await this.openSheet();
        }
    }

    private async openSheet() {
        const eventMergeId = generateEventMergeId();

        const sheetContentElement = this.getRootElement<HTMLTemplateElement>().content.cloneNode(true) as DocumentFragment;
        sheetContentElement.querySelector('.js_pdp_bounce-gate__benefit')?.setAttribute('event-merge-id', eventMergeId);

        const sheetElement = await sheetV1.create({
            id: 'pdp_bounce-gate',
            headline: 'Entdecke mehr von OTTO',
            adaptiveAlignment: 'center',
            maxWidthCentered: '80%',
            noContentPadding: true,
        });
        sheetElement.addEventListener('oc-mount', () => this.renderRecommendations(eventMergeId), { once: true });
        sheetElement.addEventListener('oc-sheet-close', () => this.trackBounceGateClosed(eventMergeId), { once: true });
        sheetElement.replaceChildren(sheetContentElement);
        sheetElement.open = true;

        this.trackBounceGate(eventMergeId);
    }

    private renderRecommendations(eventMergeId: string) {
        /*                                                                                                              */
        if (this.getRootElement().dataset.useNexusRecoCinemas === 'true') {
            /*                                                                          */
            /*                                                                                                     */
            renderBounceLayerRecommendations({ eventMergeId });
        } else {
            window.o_reco?.api.loadBounceLayerCinema({
                target: '.js_pdp_bounce-gate__recommendations',
                variationId: this.getVariationId(),
                eventMergeId,
            });
        }
    }

    private trackBounceGate(eventMergeId: string) {
        this.trackAddToEvent({ product_BounceGate: 'view' }, 'automatic', eventMergeId);
    }

    private trackBounceGateClosed(eventMergeId: string) {
        this.trackAddToEvent({ product_BounceGate: 'close' }, 'click', eventMergeId);
    }
}
